import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { Translate } from 'react-localize-redux';

// Store
import AppState from '@webapp/store/state';
import { UpdateField } from '@webapp/store/release/action-creators';

// Components
import Checkbox from '@components/form/checkbox';

// Controllers
import AnimatedHintCtrl from '@webapp/controllers/animated-hint';

interface YoutubeContentIdCtrlProps {
  className?: string;
  hasYoutubeContentID?: boolean;
  lockYoutubeContentID?: boolean;
  updateHasYoutubeContentID: (
    value: boolean
  ) => UpdateField<'hasYoutubeContentID'>;
}

const mapStateToProps = (state: AppState) => {
  return {
    hasYoutubeContentID: state.release.release?.hasYoutubeContentID,
    lockYoutubeContentID: state.release.release?.lockYoutubeContentID || false,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateHasYoutubeContentID: (value: boolean) =>
    dispatch(
      new UpdateField<'hasYoutubeContentID'>('hasYoutubeContentID', value)
    ),
});

export const YoutubeContentIdCtrl: React.FC<YoutubeContentIdCtrlProps> = ({
  updateHasYoutubeContentID,
  hasYoutubeContentID,
  lockYoutubeContentID,
  ...props
}) => {
  return (
    <div className={props.className}>
      <Checkbox
        active={!!hasYoutubeContentID}
        disabled={lockYoutubeContentID}
        onClick={() => updateHasYoutubeContentID(!hasYoutubeContentID)}
        customBorderRadius={!!hasYoutubeContentID ? '4px 4px 0 0' : undefined}
        title={<Translate id="RELEASE.DATES_STORES.YOUTUBE_CONTENT_ID.TITLE" />}
        text={<Translate id="RELEASE.DATES_STORES.YOUTUBE_CONTENT_ID.TEXT" />}
      />
      {!!hasYoutubeContentID && (
        <AnimatedHintCtrl
          className="youtube-hint"
          noBorderTop
          noMargin
          customTitle={
            <Translate id="RELEASE.DATES_STORES.YOUTUBE_CONTENT_ID.HINT.TITLE" />
          }
        >
          <Translate id="RELEASE.DATES_STORES.YOUTUBE_CONTENT_ID.HINT.TEXT" />
        </AnimatedHintCtrl>
      )}
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(YoutubeContentIdCtrl)`
  .youtube-hint {
    margin-top: 3px;
  }
`);
